import classNames from "components/ui/classNames";
import type { ReactNode } from "react";
import * as React from "react";

interface ICardValueProps {
  children: ReactNode;
}

export function CardValue({
  children,
  className,
  ...props
}: ICardValueProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLHeadingElement>, HTMLHeadingElement>) {
  return (
    <h4 className={classNames("m-0 font-aeonik text-2xl font-bold", className)} {...props}>
      {children}
    </h4>
  );
}

interface ICardDescriptionProps {
  children: ReactNode;
}

export function CardDescription({ children }: ICardDescriptionProps) {
  return <h3 className="flex font-aeonik text-sm font-medium text-gray-500">{children}</h3>;
}

interface IIconCardProps {
  primaryColor: string;
  secondaryColor: string;
  icon: ReactNode;
  children: ReactNode;
  className?: string;
}

export default function IconCard({ primaryColor, secondaryColor, icon, children, className }: IIconCardProps) {
  return (
    <div
      className={classNames(
        "relative flex w-full flex-col rounded-xl border border-slate-200 bg-white p-4 shadow-sm",
        className,
      )}
    >
      <div
        className="mb-4 flex h-7 w-7 items-center justify-center rounded-lg squircle"
        style={{
          color: primaryColor,
          backgroundColor: secondaryColor,
        }}
      >
        {icon}
      </div>

      <div className="mt-auto">{children}</div>
    </div>
  );
}
